<div class="p-form-layout01__item">
  <h3
    class="p-form-layout01__item-title p-form-layout01__item-title--l"
    [innerHTML]="'label.creditCard' | staticMsg"
  ></h3>
  <!-- クレジットカード情報 -->
  <div class="p-input-block01">
    <div class="p-input-block01__item">
      <form [formGroup]="cardInfoFormGroup">
        <!-- 利用可能なクレジットカード -->
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <!-- 見出し -->
          <div class="p-input-block01__row-head u-display-block-pc">
            <span class="p-input-block01__row-title" [innerHTML]="'message.applicableCreditCards' | staticMsg"> </span>
          </div>
          <!-- ブランド一覧 -->
          <div class="p-input-block01__row-body">
            <div class="p-input-block01__row-body-item">
              <ng-container *ngFor="let item of CardBrandImageMap.values()">
                <img src="assets/images/{{ item }}.png" alt="{{ getAltText(item) | staticMsg }}" />
              </ng-container>
            </div>
          </div>
        </div>
        <!-- クレジットカード情報 -->
        <div class="p-input-block01__row p-input-block01__row--has-title">
          <!-- 見出し -->
          <div class="p-input-block01__row-head u-display-block-pc">
            <span class="p-input-block01__row-title" [innerHTML]="'label.alwaysInformation' | staticMsg"> </span>
          </div>
          <!-- カード情報 -->
          <div class="p-input-block01__row-body">
            <!-- クレジットカード番号 -->
            <div class="p-input-block01__row-body-item p-input-block01__row-body-item--mt16">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <div
                  *ngIf="
                    selectedCard !== 'paymentCard1' &&
                    selectedCard !== 'paymentCard2' &&
                    selectedCard !== 'paymentCard3'
                  "
                >
                  <asw-input
                    id="payment-input-card-info-input-1"
                    label="{{ 'label.creditCardNumber' | staticMsg }}"
                    formControlName="cardNumber"
                    (change$)="cardNumberChange()"
                    maxlength="16"
                    [required]="!isSkyCoinSelected"
                    placeholder="{{ 'placeholder.creditCardNumber' | staticMsg }}"
                  ></asw-input>
                </div>
                <div
                  *ngIf="
                    selectedCard === 'paymentCard1' ||
                    selectedCard === 'paymentCard2' ||
                    selectedCard === 'paymentCard3'
                  "
                  class="c-form-element-input"
                >
                  <div class="c-form-element-input__box">
                    <label class="c-form-element-input__wrap">
                      <span class="c-form-element-input__label"
                        ><span
                          class="c-form-element-input__label-text"
                          [innerHTML]="'label.creditCardNumber' | staticMsg"
                        >
                        </span>
                      </span>
                      <span class="c-form-element-input__input">
                        <input
                          type="text"
                          id="payment-input-card-info-input-2"
                          name="payment-input-card-info-input-2"
                          class="c-form-element-input__input-item"
                          value="{{ selectedCreditCardNumber }}"
                          readonly="readonly"
                          placeholder="{{ 'placeholder.creditCardNumber' | staticMsg }}"
                          aria-required="true"
                          aria-invalid="false"
                        />
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 有効期限 -->
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-head">
                <span class="p-input-block01__row-title" [innerHTML]="'label.expirationDate' | staticMsg"> </span>
                <span
                  *ngIf="!isSkyCoinSelected"
                  class="c-label-required"
                  [innerHTML]="'m_static_message-message.mandatory' | staticMsg"
                >
                </span>
              </div>
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-select-date-ym
                  id="payment-input-card-info-select-1"
                  formControlName="cardExpiryDate"
                  (change$)="expiryChange()"
                  [yearRange]="[this.yearRange, this.yearRange + 14]"
                ></asw-select-date-ym>
              </div>
            </div>
            <!-- セキュリティコード -->
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  type="password"
                  id="payment-input-card-info-input-4"
                  autocomplete="cc-csc"
                  label="{{ 'label.securityCode' | staticMsg }}"
                  formControlName="securityCode"
                  (change$)="cvvChange()"
                  maxlength="4"
                  [required]="!isSkyCoinSelected"
                  placeholder="{{ 'placeholder.securityCode' | staticMsg }}"
                ></asw-input>
              </div>
            </div>
            <!-- カード名義 -->
            <div class="p-input-block01__row-body-item">
              <div class="p-input-block01__row-body-item-box p-input-block01__row-body-item-box--w325">
                <asw-input
                  id="payment-input-card-info-input-5"
                  label="{{ 'label.cardholderName' | staticMsg }}"
                  formControlName="ownerName"
                  (change$)="holderNameChange()"
                  maxlength="40"
                  [required]="!isSkyCoinSelected"
                  placeholder="{{ 'placeholder.cardholderName' | staticMsg }}"
                ></asw-input>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
